export const TOP_BAR_HEIGHT = 16; // 64px
export const DECK_DRAWER_CLOSED_WIDTH = 72; // 288px
export const DECK_DRAWER_OPEN_WIDTH = "35%";
export const TOP_ALERT_HEIGHT = 12; // 48px
export const DISCORD_INV = "https://discord.gg/keqVtfX57z";
export const SPREADSHEET_LINK =
  "https://drive.google.com/drive/folders/1Iz3ttSvQNkzHRFnBpzzKRg_avblT6l4q";
export const BOT_INV =
  "https://discord.com/api/oauth2/authorize?client_id=1000344271536263219&permissions=2048&scope=applications.commands%20bot";
